import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const getEmptyEvent = () => {
  return {
    title: "",
    description: "",
    teamDetails: "",
    link: "",
    registration: "",
    date: "",
    time: "",
    venue: "",
    host: "",
    duration: "",
    mode: "Offline",
  };
};

function EventForm() {
  const [event, setEvent] = useState(getEmptyEvent());
  const poster = useRef(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setEvent({
      ...event,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("UnAuthorized");
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const formData = new FormData();
      for (const key in event) {
        formData.append(key, event[key]);
      }
      formData.append("poster", poster.current.files[0]);
      const response = await axios.post(`${BASE_URL}/events`, formData, config);
      if (response.data.success === true) {
        alert("Event added successfully");
        navigate("/admin/events");
      } else {
        throw new Error(response.data.message);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleReset = () => {
    setEvent(getEmptyEvent());
  };

  return (
    <div className="py-3 container is-fluid">
      <form encType="multipart/form-data">
        <div className="columns is-centered">
          <div className="column is-two-thirds">
            <div className="field">
              <label className="label">Event Title</label>
              <div className="control">
                <input
                  autoFocus
                  name="title"
                  className="input"
                  value={event.title}
                  type="text"
                  placeholder="Event Title"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Event Description</label>
              <div className="control">
                <textarea
                  name="description"
                  className="textarea"
                  value={event.description}
                  placeholder="Event description"
                  onChange={handleChange}
                ></textarea>
              </div>
            </div>

            <div className="field">
              <label className="label">Event Team Details</label>
              <div className="control">
                <textarea
                  name="teamDetails"
                  className="textarea"
                  value={event.teamDetails}
                  placeholder="Event Team Details"
                  onChange={handleChange}
                ></textarea>
              </div>
            </div>

            <div className="field">
              <label className="label">Event Poster</label>
              <div className="control">
                <input
                  name="poster"
                  className="input"
                  type="file"
                  ref={poster}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Event Registration Link</label>
              <div className="control">
                <input
                  name="registration"
                  className="input"
                  type="text"
                  value={event.registration}
                  placeholder=""
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Event Link</label>
              <div className="control">
                <input
                  name="link"
                  className="input"
                  type="text"
                  value={event.link}
                  placeholder="event@example.com"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Event Date</label>
              <div className="control">
                <input
                  name="date"
                  className="input"
                  type="date"
                  value={event.date}
                  placeholder=""
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Event Time</label>
              <div className="control">
                <input
                  name="time"
                  className="input"
                  type="time"
                  value={event.time}
                  placeholder=""
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Event Duration</label>
              <div className="control">
                <input
                  name="duration"
                  className="input"
                  type="text"
                  value={event.duration}
                  placeholder=""
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Event Hosts</label>
              <div className="control">
                <input
                  name="host"
                  className="input"
                  type="text"
                  value={event.host}
                  placeholder=""
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Event Venue</label>
              <div className="control">
                <input
                  name="venue"
                  className="input"
                  type="text"
                  value={event.venue}
                  placeholder="Ravindra Kala Bharathi"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Event mode</label>
              <div className="control">
                <div className="select">
                  <select
                    defaultValue={event.mode}
                    onChange={handleChange}
                    name="mode"
                  >
                    <option value="Offline">Offline</option>
                    <option value="Online">Online</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="field is-grouped">
              <div className="control">
                <button
                  type="submit"
                  className="button is-link is-success"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
              <div className="control">
                <button
                  type="reset"
                  className="button is-link is-light is-danger"
                  onClick={handleReset}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EventForm;
